import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UserLiftPermission } from '../models/user-lift-permission.model';

@Injectable({
  providedIn: 'root'
})
export class UserLiftPermissionService {
  apiUrl: string;
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.apiUrl = baseUrl + 'api/liftPermission';
  }

  getUserPermission(loginId: number) {
    const url = this.apiUrl + '/' + String(loginId);
    return this.httpClient.get<UserLiftPermission>(url);
  }

  setUserPermission(loginId: number, data) {
    return this.httpClient.put(this.apiUrl + '/' + String(loginId), JSON.stringify(data), { headers: this.headers });
  }

  getLoggedUserLiftPermission(liftId: number) {
    const companies = JSON.parse(localStorage.getItem('loginCompanies'));
    const loginId = companies[0].loginId;
    const url = this.apiUrl + '/' + String(loginId) + '/lift';
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Lift-Id': String(liftId) });

    return this.httpClient.get<any>(url, { headers: this.headers });
  }
}
